import { addDays, format, isSameDay } from 'date-fns';
import { Link } from 'react-router';
import { toFullDayDateString } from '@/utils/datetime';

interface WeekDayNavigationItemProps {
  dayStartAt: Date;
  today: Date;
}

function WeekDayNavigationItem({
  dayStartAt,
  today,
}: WeekDayNavigationItemProps) {
  const dateString = toFullDayDateString(dayStartAt);
  const dayLabel = format(dayStartAt, 'EEE').charAt(0);

  const isToday = isSameDay(dayStartAt, today);
  const isFuture = dayStartAt > today && !isToday;

  const className = [
    'flex h-7 w-7 items-center text-foreground justify-center rounded border transition-all border-muted-background hover:text-black hover:bg-muted',
    isToday ? 'underline' : '',
    isFuture ? 'text-muted-foreground' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Link to={`/${dateString}`} className={className}>
      {dayLabel}
    </Link>
  );
}

interface WeekDayNavigationProps {
  weekStartAt: Date;
}

export function WeekDayNavigation({ weekStartAt }: WeekDayNavigationProps) {
  const days = Array.from({ length: 7 }, (_, i) => {
    return addDays(weekStartAt, i);
  });
  const today = new Date();

  return (
    <div className="flex gap-1">
      {days.map((dayStartAt, index) => (
        <WeekDayNavigationItem
          key={index}
          today={today}
          dayStartAt={dayStartAt}
        />
      ))}
    </div>
  );
}
